export const products = {
  // Main Products Page
  mainHero: {
    title: "Ürünlerimiz",
    subtitle: "Premium kahve, çay ve içecek çözümlerimizi keşfedin"
  },

  // Coffee Section
  coffee: {
    title: "KAVRULMUŞ KAHVE",
    description: "En seçkin menşelerden temin edilen premium kavrulmuş kahve çekirdekleri",
    button: "Kahveleri Keşfet"
  },

  // Milkshakes Section
  milkshakes: {
    title: "MİLKSHAKE",
    description: "Her damak zevkine uygun, lezzetli ve kremamsı milkshake karışımları",
    button: "Milkshake’leri Keşfet"
  },

  // HoReCa Section
  horeca: {
    title: "HORECA ÇÖZÜMLERİ",
    description: "Otel, restoran ve kafeler için profesyonel ürünler",
    button: "HoReCa’yı Keşfet"
  },

  // Tea Section
  tea: {
    title: "ÇAY",
    description: "Premium çay seçkisi",
    button: "Çayları Keşfet",
    comingSoon: "Çok Yakında"
  },

  // Machines Section
  machines: {
    title: "KAHVE & ÇAY MAKİNELERİ",
    description: "Profesyonel demleme ekipmanları",
    button: "Makineleri Keşfet",
    comingSoon: "Çok Yakında"
  },

  // Roasted Coffee Page
  roastedCoffee: {
    hero: {
      title: "Kavrulmuş Kahve",
      subtitle: "Mükemmelliğe ulaşacak şekilde kavrulmuş premium kahve çekirdekleri",
      label: "KAHVE KOLEKSİYONU"
    },
    intro: {
      title: "Artizan Kavurma Ustalığı",
      description: "Kavrulmuş kahve koleksiyonumuz, kahve zanaatkârlığının zirvesini temsil eder. Dünyanın en seçkin kahve yetiştirme bölgelerinden özenle seçilen her çekirdek, kahve tutkunlarının değer verdiği özgün aroma ve tat profillerini ortaya çıkarmak için mükemmel şekilde kavrulur."
    },
    seeDetails: "Detayları Gör"
  },

  // Pods Page
  pods: {
    hero: {
      title: "Kahve Podları",
      subtitle: "Pratik tek kullanımlık kahve çözümleri",
      label: "ESE 44MM POD"
    },
    intro: {
      title: "Her Zaman Mükemmel Kahve",
      description: "Kahve podlarımız, tutarlı kalite ve kullanım kolaylığı sunar. Her bir pod, taze kavrulmuş kahvenin zengin aroma ve lezzetini koruyacak şekilde özenle hazırlanır ve her fincanda kusursuz bir deneyim sağlar."
    },
    seeDetails: "Detayları Gör"
  },

  // Capsules Page
  capsules: {
    hero: {
      title: "Uyumlu Kapsüller",
      subtitle: "Kahve makineniz için premium kapsüller",
      label: "UYUMLU KAPSÜLLER"
    },
    intro: {
      title: "Uyumluluk ve Kalitenin Buluşması",
      description: "Uyumlu kapsüllerimiz, popüler kahve makineleriyle kusursuz şekilde çalışacak biçimde tasarlanmıştır ve üstün lezzet sunar. Taviz vermeden premium kahve deneyimi yaşayın."
    },
    seeDetails: "Detayları Gör"
  },

  // Milkshakes Page
  milkshakesPage: {
    hero: {
      title: "Milkshake",
      subtitle: "Kremamsı ve lezzetli milkshake karışımları",
      label: "MİLKSHAKE KOLEKSİYONU"
    },
    intro: {
      title: "Keyif Veren Milkshake Deneyimi",
      description: "Milkshake koleksiyonumuz, her yaştan müşteriyi memnun eden zengin ve kremamsı lezzet çeşitleri sunar. Kafeler, restoranlar ve dondurmacılar için idealdir."
    },
    seeDetails: "Detayları Gör"
  },

  // HoReCa Page
  horecaPage: {
    hero: {
      title: "HoReCa Çözümleri",
      subtitle: "Konaklama sektörü için profesyonel ürünler",
      label: "PROFESYONEL ÇÖZÜMLER"
    },
    intro: {
      title: "Mutfak Yaratımlarınızı Yükseltin",
      description: "HoReCa ürün grubumuz, otel, restoran ve kafelerde profesyonel kullanım için özel olarak geliştirilmiştir. Pralinlerden soslara kadar her ürün, en yüksek kalite ve tutarlılık standartlarını karşılar."
    },
    categories: {
      pralines: "Pralinler",
      fillingCreams: "Dolgu Kremleri",
      fillingFruits: "Meyve Dolguları",
      toppingSauces: "Topping Soslar",
      decorSauces: "Dekor Soslar",
      coldGlazes: "Soğuk Glazeler",
      coffeeBarSauces: "Kahve Barı Sosları"
    },
    seeDetails: "Detayları Gör"
  },

  // Tea Page
  teaPage: {
    hero: {
      title: "Premium Çay Koleksiyonu",
      subtitle: "Çok Yakında",
      label: "ÇAY KOLEKSİYONU"
    },
    comingSoonText: "Rafine lezzette yeni bir bölüm",
    description: "Geleneklere saygı duyarken inovasyonu benimseyen özel bir çay koleksiyonu hazırlıyoruz. Olağanüstü bir deneyim için bizi takip edin."
  },

  // Machines Page
  machinesPage: {
    hero: {
      title: "Kahve & Çay Makineleri",
      subtitle: "Çok Yakında",
      label: "EKİPMAN"
    },
    comingSoonText: "Mükemmellik için profesyonel ekipmanlar",
    description: "Her fincanda kusursuzluk talep eden profesyoneller için tasarlanmış premium kahve ve çay makinelerinden oluşan bir seçki hazırlıyoruz."
  },

  // Chocolate Page
  chocolatePage: {
    hero: {
      title: "Premium Çikolata Koleksiyonu",
      subtitle: "Çok Yakında",
      label: "ÇİKOLATA"
    },
    comingSoonText: "Keyif yeniden tanımlanıyor",
    description: "Sanat ve olağanüstü lezzeti bir araya getiren rafine bir çikolata koleksiyonu hazırlıyoruz. Gerçek anlamda büyüleyici bir deneyim için bizi takip edin."
  },

  // Elite Coffee Page
  eliteCoffee: {
    hero: {
      title: "Elite Kahve Koleksiyonu",
      subtitle: "Çok Yakında",
      label: "ELITE KAHVE"
    },
    comingSoonText: "Kahve sanatının zirvesi",
    description: "Dünyanın en prestijli çiftliklerinden temin edilen olağanüstü bir elit kahve koleksiyonu hazırlıyoruz. Sıradanlığın ötesinde bir kahve deneyimi."
  },

  // Elite Milkshake Page
  eliteMilkshake: {
    hero: {
      title: "Elite Milkshake Koleksiyonu",
      subtitle: "Çok Yakında",
      label: "ELITE MILKSHAKE"
    },
    comingSoonText: "Kremamsı keyif zirveye taşınıyor",
    description: "Kremamsı lezzeti yeniden tanımlayan lüks bir milkshake koleksiyonu hazırlıyoruz. Benzersiz bir tat deneyimine hazır olun."
  },

  // Elite Tea Page
  eliteTea: {
    hero: {
      title: "Elite Çay Koleksiyonu",
      subtitle: "Çok Yakında",
      label: "ELITE ÇAY"
    },
    comingSoonText: "Zamansız bir ritüel mükemmelleştiriliyor",
    description: "Asırlık geleneği modern incelikle buluşturan bir koleksiyon yaratmak için dünyanın en nadide çay yapraklarını tedarik ediyoruz."
  },

  // Elite Pods Page
  elitePods: {
    hero: {
      title: "Elite Kahve Podları",
      subtitle: "En seçkin tek kullanımlık espresso deneyimi",
      label: "ELITE ESE 44MM POD"
    },
    seeDetails: "Detayları Gör"
  },

  // Refresher Page
  refresherPage: {
    hero: {
      title: "Refresher",
      subtitle: "Canlı ve ferahlatıcı içecek çözümleri",
      label: "REFRESHER KOLEKSİYONU"
    },
    seeDetails: "Detayları Gör"
  },

  // Etiyopya Sayfasi
  ethiopian: {
    hero: {
      title1: "Etiyopya",
      title2: "Zarafeti,",
      title3: "Her Fincanda",
      title4: "Rafine",
      description: "Kahvenin anavataninda dogan,",
      description2: "miras, aroma ve lüksü takdir edenler için özenle hazirlanmistir.",
      cta: "Lezzetin Derinligini Kesfedin"
    },
    features: {
      origin: "ETIYOPYA MENSELI",
      roasted: "KAVRULMUS KAHVE",
      weight: "1 kg NET AGIRLIK",
      gift: "LUKS HEDIYE SUNUMU",
      heritage: "PREMIUM MIRAS"
    },
    origin: {
      title1: "Etiyopya'nin",
      title2: "Kalbi",
      description: "Kahvenin dogdugu yerden, Lucendo Elite Etiyopya, yüksek rakimlar, verimli toprak ve nesillerdir süren zanaatkarlikla sekillenen ayirt edici bir karakter sunar."
    },
    taste: {
      label: "TAT PROFILI",
      richAroma: {
        title: "ZENGIN AROMA",
        description: "Çiçeksi ve davetkar"
      },
      smoothBody: {
        title: "YUMUSAK VUCUT",
        description: "Kadifemsi ve dengeli"
      },
      elegantFinish: {
        title: "ZARIF BITIS",
        description: "Temiz ve kalici"
      },
      refinedRoast: {
        title: "RAFINE KAVURMA",
        description: "Derinlik ve saflik için ustalikla islenmis"
      }
    },
    gift: {
      title1: "Olaganustu",
      title2: "Hediye icin Uretildi",
      description: "Içindeki zarafeti yansitan premium bir hediye seti olarak sunulur."
    },
    closing: {
      title1: "Kahveden Fazlasi.",
      title2: "Bu Bir Miras.",
      description: "Lucendo Elite Etiyopya, menşe, zanaatkarlik ve zamansiz lüksün bir kutlamasidir."
    }
  },

  // Kolombiya Sayfasi
  colombian: {
    hero: {
      title: "KOLOMBİYA",
      subtitle: "KAVRULMUŞ KAHVE ÇEKİRDEKLERİ",
      tagline: "Taze Menşe. Rafine Lüks.",
      description: "Tek menşeli Kolombiya kahvesi, her fincanda olağanüstü kalite ve zamansız incelik takdir edenler için özenle hazırlanmıştır."
    },
    features: {
      singleOrigin: "TEK MENŞELİ KOLOMBİYA",
      arabica: "%100 ARABİKA",
      roasted: "KAVRULMUŞ KAHVE ÇEKİRDEKLERİ",
      weight: "1 kg e",
      madeInItaly: "İTALYA'DA ÜRETİLMİŞTİR"
    },
    origin: {
      label: "MENŞEİMİZ",
      title1: "Kolombiya'nın Yüksek",
      title2: "Dağlık Bölgelerinin Kalbinden",
      paragraph1: "Çekirdeklerimiz, Kolombiya'nın en ünlü yüksek rakımlı bölgelerinden gelmektedir; zengin volkanik toprak, ideal iklim ve nesillerdir süren uzmanlık, olağanüstü kalitede kahve yaratır.",
      paragraph2: "Her hasat, doğaya, geleneğe ve mükemmellik arayışına derin bir saygıyı yansıtır."
    },
    taste: {
      label: "TAT PROFİLİ",
      balancedAroma: {
        title: "DENGEli AROMA",
        description: "Narin meyvemsi notalarla zengin ve davetkar."
      },
      smoothBody: {
        title: "YUMUŞAK VÜCUT",
        description: "Derinlikle kadifemsi ve dengeli."
      },
      elegantFinish: {
        title: "ZARİF BİTİŞ",
        description: "Temiz, kalıcı ve güzelce rafine."
      },
      premiumRoast: {
        title: "PREMIUM KAVURMA",
        description: "Gerçek karakteri öne çıkarmak için uzmanca kavrulmuş."
      }
    },
    closing: {
      title1: "Zamansız Lüks.",
      title2: "Her Çekirdekte Mükemmelleştirilmiş.",
      description: "Lucendo Elite Colombian bir kahveden fazlasıdır — Menşe, zanaat ve değerli anların kutlanmasıdır."
    }
  }
};
